import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { convertTimeLetter, formatTimeEvent } from '@helpers';
import Svg from '@styles/icons/svg';

import { RankBadgeVariant } from '@v2/pages/dashboard/common/types/rows';

interface DashboardOverviewBottomBlockRowValueProps extends WithColor {
  seconds: number;
  variant: RankBadgeVariant;
}

const VALUE_COLOR_BY_VARIANT: Record<RankBadgeVariant, string> = {
  [RankBadgeVariant.Worst]: 'System/Light/Red',
  [RankBadgeVariant.Best]: 'System/Light/Green',
  [RankBadgeVariant.Actual]: 'System/Light/Blue',
};

const VALUE_SIGN_BY_VARIANT: Record<RankBadgeVariant, string> = {
  [RankBadgeVariant.Worst]: '-',
  [RankBadgeVariant.Best]: '+',
  [RankBadgeVariant.Actual]: '',
};

const DashboardOverviewBottomBlockRowValue: FC<DashboardOverviewBottomBlockRowValueProps> = ({ C, seconds, variant }) => {
  const colorKey = VALUE_COLOR_BY_VARIANT[variant];
  const sign = VALUE_SIGN_BY_VARIANT[variant];
  const text = formatTimeEvent(convertTimeLetter(Math.abs(seconds)), false, false).trim();

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(8) }}>
      <Text style={[font['Subhead 1 bold'], { color: C(colorKey) }]}>
        {sign}
        {text}
      </Text>
      <Svg icon="chevronRight" color="Label/Light/Quinary" width={scale(15)} height={scale(15)} />
    </View>
  );
};

export default ColorWrapper(DashboardOverviewBottomBlockRowValue);
